import React from 'react';

function About(){
    return(
        <>
        <section id="about"></section>
        <div className="title-place"><h2>ABOUT</h2></div>
        <div className="about-card center-content">
            <p className='text-justify reduce-width'>
            Since childhood, I've been captivated by understanding how things work, particularly in the realms of electronics and music. Experimenting with circuits and various components became a favorite pastime.
            However, it was during high school that I encountered teachers and friends who fueled my curiosity, especially in the realm of computers. With their guidance and access to additional resources, my fascination with technology grew even deeper. <br /><br />
            This newfound passion led me to pursue admission to the most prestigious technological university in my country. Along the way, I was fortunate to have the support of influential individuals who served as mentors, inspiring me to blend my love for computers and music into a spirit of creativity and innovation. This journey has instilled in me a desire to continue pushing boundaries and exploring the endless possibilities at the intersection of technology and art.
            </p>
        </div>
        </>
    );

}

export default About; 